import { render } from "./SlotSwipper.vue?vue&type=template&id=106f140a&scoped=true"
import script from "./SlotSwipper.vue?vue&type=script&lang=js"
export * from "./SlotSwipper.vue?vue&type=script&lang=js"

import "./SlotSwipper.vue?vue&type=style&index=0&id=106f140a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-106f140a"]])

export default __exports__